// removed by extract-text-webpack-plugin
module.exports = {"container":"_1zhh3M8RdyXn7XKkIkOZUm","title":"_3b5_T2Wg10vAAXOJX-rtHK"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Custom/AllProducts/styles.css
// module id = 3242
// module chunks = 0